export type ClientInvoiceStatusTone = 'paid' | 'overdue' | 'default' | 'empty';

export interface ClientInvoiceStatusMeta {
  label: string;
  color: string;
  iconBg: string;
  tone: ClientInvoiceStatusTone;
  showIcon: boolean;
}

const toTitleCase = (value: string): string =>
  value
    .replace(/[_-]+/g, ' ')
    .trim()
    .replace(/\b\w/g, (letter) => letter.toUpperCase());

export const getClientInvoiceStatusMeta = (value: string | null | undefined): ClientInvoiceStatusMeta => {
  const rawStatus = String(value ?? '').trim();
  if (!rawStatus) {
    return { label: '—', color: '#64748b', iconBg: '#e5e7eb', tone: 'empty', showIcon: false };
  }

  const status = rawStatus.toLowerCase();
  if (status === 'paid') {
    return { label: 'Paid', color: '#073545', iconBg: '#8ad7e8', tone: 'paid', showIcon: true };
  }

  if (status === 'overdue') {
    return { label: 'Overdue', color: '#073545', iconBg: '#ffb7bc', tone: 'overdue', showIcon: true };
  }

  return { label: toTitleCase(rawStatus), color: '#073545', iconBg: '#e5e7eb', tone: 'default', showIcon: false };
};
